export const SET_MIN_USEFUL_AREA = 'SET_MIN_USEFUL_AREA';
export const setMinUsefulArea = (payload: any) => ({
  type: SET_MIN_USEFUL_AREA,
  payload,
});

export const SET_MAX_USEFUL_AREA = 'SET_MAX_USEFUL_AREA';
export const setMaxUsefulArea = (payload: any) => ({
  type: SET_MAX_USEFUL_AREA,
  payload,
});

export const SET_MIN_DATE = 'SET_MIN_DATE';
export const setMinDate = (payload: any) => ({
  type: SET_MIN_DATE,
  payload,
});

export const SET_MAX_DATE = 'SET_MAX_DATE';
export const setMaxDate = (payload: any) => ({
  type: SET_MAX_DATE,
  payload,
});

export const SET_REALTY_TYPE = 'SET_REALTY_TYPE';
export const setRealtyType = (payload: any) => ({
  type: SET_REALTY_TYPE,
  payload,
});

export const RESET_FILTERS = 'RESET_FILTERS';
export const resetFilters = () => ({
  type: RESET_FILTERS,
});

export const SET_MIN_MAX_AREA_LOCAL_FILTERS = 'SET_MIN_MAX_AREA_LOCAL_FILTERS';
export const setMinMaxAreaLocalFilters = (payload: any) => ({
  type: SET_MIN_MAX_AREA_LOCAL_FILTERS,
  payload,
});

export const SET_MIN_MAX_DATE_LOCAL_FILTERS = 'SET_MIN_MAX_DATE_LOCAL_FILTERS';
export const setMinMaxDateLocalFilters = (payload: any) => ({
  type: SET_MIN_MAX_DATE_LOCAL_FILTERS,
  payload,
});

export const SET_IS_GRID_VIEW = 'SET_IS_GRID_VIEW';
export const setIsGridView = (payload: boolean) => ({
  type: SET_IS_GRID_VIEW,
  payload,
});

export const SET_MAX_REALTY_AGE = 'SET_MAX_REALTY_AGE';
export const setMaxRealtyAge = (payload: number) => ({
  type: SET_MAX_REALTY_AGE,
  payload,
});

export const SET_MIN_REALTY_AGE = 'SET_MIN_REALTY_AGE';
export const setMinRealtyAge = (payload: number) => ({
  type: SET_MIN_REALTY_AGE,
  payload,
});
